var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeVoiture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        mask: url(#mask);\n      }\n\n      .cls-6 {\n        filter: url(#luminosity-invert);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #ad974f;\n        fill-rule: evenodd;\n      }\n\n      .cls-4 {\n        fill: #000;\n        fill-opacity: .6;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-invert",
    x: -100.4,
    y: 0,
    width: 700.9,
    height: 700.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -100.4,
    y: 0,
    width: 700.9,
    height: 700.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_35a0c5fd33",
    "data-name": "35a0c5fd33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -100.4,
    y: 0,
    width: 700.9,
    height: 700.9
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.1,
    y: 105.2,
    width: 401.8,
    height: 289.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.4,
    y: 108.7,
    width: 397.2,
    height: 283.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.9,214.7c-6.3,21.8-11.7,30.8-11.8,57.6,0,23.4,0,46.9,0,70.3,0,31.3,2.2,35.4,34.3,35.5,33.2.1,29.2-12.3,29.3-41.6l217.4-.2c.2,28.2-3.6,41.9,27.9,41.8,45.1-.1,35.6-8.4,35.7-104.2,0-25.8-4.6-37.8-11.9-59.2,21.3-.7,47.1-49.8-17.2-39.8-3.4-10.6-8-20.6-12.5-31-5.6-13.2-6-17.5-15-26.7-7.7-7.8-18.6-11-30.9-11.7l-5.5-.3-165.6.5c-30.7.3-37.1,21.5-45.2,40.3-3.1,7.3-8.6,23.6-13,28.6-61.9-9.3-37,39.3-16,40.1ZM167.1,294.4v-32.7h174v32.7h-174ZM142.9,283.1c0,10.7-8.8,19.4-19.6,19.4s-19.6-8.7-19.6-19.4,8.8-19.4,19.6-19.4,19.6,8.7,19.6,19.4ZM403.3,283.1c0,10.7-8.8,19.4-19.6,19.4s-19.6-8.7-19.6-19.4,8.8-19.4,19.6-19.4,19.6,8.7,19.6,19.4ZM169.1,122.2c12-3.1,71.1-1,88.4-1,87.9,0,87.2-9,103.9,31.2,4.3,10.6,8.9,21.3,13.2,31.7,3.5,8.6,14.7,26.6,5.9,33-6.5,4.8-204.6,2.2-223.1,2.2-42.3,0-40.6,1.7-22.8-41.1,10.3-24.8,16.3-51.3,34.6-56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeVoiture);
export default __webpack_public_path__ + "static/media/Icone-voiture.3b722362bf2fd7152a614eef7b2f0255.svg";
export { ForwardRef as ReactComponent };